import { createVenueAgreement, fetchVenueAgreements } from "./api";

// Build a plain-text agreement body that includes the DPA text and acceptance details
export function buildAgreementText({ dpaText, details, clientIp, userAgent }) {
  const {
    firstName = "",
    lastName = "",
    email = "",
    restaurantName = "",
    address = "",
    venueId = "",
    userId = "",
    googlePlaceId = "",
    agreementAcceptedAt = "",
    partnerNotice = "",
  } = details || {};

  const ua = userAgent || (typeof navigator !== "undefined" ? navigator.userAgent : "");
  const ip = clientIp || "";

  return (
    `${dpaText}\n\n` +
    `--- Acceptance Details ---\n` +
    (partnerNotice ? `Partner Notice: ${partnerNotice}\n` : "") +
    `Name: ${firstName} ${lastName}\n` +
    `Email: ${email}\n` +
    `Restaurant Name: ${restaurantName}\n` +
    `Address: ${address}\n` +
    `Venue ID: ${venueId}\n` +
    `User ID: ${userId}\n` +
    `Google Place ID: ${googlePlaceId}\n` +
    `IP: ${ip}\n` +
    `User-Agent: ${ua}\n` +
    `Accepted At: ${agreementAcceptedAt}`
  );
}

// Check if an agreement exists for a given venue and product (default: rwg)
export async function fetchExistingAgreement(venueId, product = "rwg") {
  const agreements = await fetchVenueAgreements(venueId);
  const list = Array.isArray(agreements) ? agreements : (agreements?.data || []);
  return list.find((a) => (a.product || a.type) === product) || null;
}

// Submit a new agreement for a venue
export async function submitAgreement({
  venueId,
  product = "rwg",
  details,
  dpaText,
  clientIp,
  userAgent,
}) {
  const agreementText = buildAgreementText({ dpaText, details, clientIp, userAgent });
  const payload = {
    product,
    acceptedAt: details.agreementAcceptedAt,
    acceptedByUserId: details.userId,
    acceptedByFirstName: details.firstName,
    acceptedByLastName: details.lastName,
    restaurantName: details.restaurantName,
    address: details.address,
    googlePlaceId: details.googlePlaceId,
    agreementText,
  };
  return await createVenueAgreement(venueId, payload);
}


